// @ts-check
import ScimIcon from './scim-icon.svg';
import SettingStatusBar from '../../../../components/SettingStatusBar/SettingStatusBar';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';
import useScimSetting from 'common/hooks/settings/useScimSetting';
import { LBButton } from '@linearb/buzz';


const ScimStatusBar = ({ isLoading = false, withCTA = false }) => {
  const history = useHistory();
  const scimSetting = useScimSetting();

  const redirectToScimSettings = () =>
    history.push(AppRouter.AUTHENTICATION_SETTINGS_SCIM_PROVISIONING.path);

  return (
    <div>
      <SettingStatusBar
        isLoading={isLoading}
        enabled={scimSetting.isEnabled}
        logo={ScimIcon}
        title='SCIM Provisioning'
        renderDisabled='Not Set Up'
      >
        {withCTA && (
          <LBButton variant='outline' onClick={redirectToScimSettings}>
            Edit SCIM
          </LBButton>
        )}
      </SettingStatusBar>
    </div>
  );
};

export default ScimStatusBar;
